import { MonthPrice, MonthType } from '../common';

export interface CalculateHeightOptions {
  height: number;
  minPrice: number;
  maxPrice: number;
  minHeight: number;
}

const getType = (amount: string, minPrice: number, maxPrice: number): MonthType => {
  switch (true) {
    case +amount === minPrice:
      return MonthType.MIN;
    case +amount === maxPrice:
      return MonthType.MAX;
    default:
      return MonthType.OTHER;
  }
};

export const calculateHeight = (
  { price: { amount }, isCheapest }: MonthPrice,
  { minPrice, maxPrice, minHeight, height }: CalculateHeightOptions
): string => {
  const type = isCheapest ? MonthType.MIN : getType(amount, minPrice, maxPrice);

  if (minPrice === maxPrice || type === MonthType.MIN) {
    return `${minHeight}px`;
  }

  if (+amount === maxPrice) {
    return `${height}px`;
  }

  const percentOfAmount = ((+amount - minPrice) / (maxPrice - minPrice)) * 100;
  const freeArea = height - minHeight;
  const extraHeightInPx = (freeArea * percentOfAmount) / 100;

  return `${minHeight + extraHeightInPx}px`;
};
